import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, Form, Flex, Button} from 'antd';
import { useBnsJiaoChengDelMutation, useBnsJiaoChengListQuery } from '../../store/ReactWebSiteApi';
import TechDocEdit from './TeachEdit';
import ModalDel from '../../cpn/ModalDel';
import TeachCheck from './TeachCheck';
import TeachAdd from './TeachAdd';
import CourseList from './CourseList';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
function TeachList() {       
    const [list, setList] = useState();    
    const [query,setQuery] = useState({bjc_e_id:localStorage.getItem('e_id'),bjc_eowg_id:'',bjc_eowg_type_id:''})
    const {data, isSuccess} = useBnsJiaoChengListQuery(query,{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bjc_id:key,bjc_name,bjc_ctime,bjc_cname,bjc_content,bjc_dept_id,bjc_dept_name,bjc_bg_name,bjc_eowg_name,bjc_eowg_id,bjc_bg_id,bjc_bgn_id,bjc_bgn_name} = item;
                    return item = {key,bjc_name,bjc_ctime,bjc_cname,bjc_content,bjc_dept_id,bjc_dept_name,bjc_bg_name,bjc_eowg_name,bjc_eowg_id,bjc_bg_id,bjc_bgn_id,bjc_bgn_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bjc_ctime;
                    let bTimeString = b.bjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [   
        {
            key: 'list',
            title: '教程名称',
            render:(_,record) => {
                return  <TeachCheck 
                            bjc_name={record.bjc_name}
                            bjc_content={record.bjc_content}
                            bjc_id={record.key}
                            bjc_dept_id={record.bjc_dept_id}
                            bjc_dept_name={record.bjc_dept_name}
                            bjc_type_name={record.bjc_type_name}
                        />
            }            
        },      
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            width:'3%'
            
        },          
        {
            key: 'bjc_bg_name',
            title: '商品类型名称',            
            dataIndex:'bjc_bg_name'
        },    
        {
            key: 'bjc_bg_id',
            title: '编号',            
            dataIndex:'bjc_bg_id',
            width:'3%'
        },    
        {
            key: 'bjc_bgn_name',
            title: '子类型名称',            
            dataIndex:'bjc_bgn_name'
        },    
        {
            key: 'bjc_bgn_id',
            title: '编号',            
            dataIndex:'bjc_bgn_id',
            width:'3%'
        },    
        {
            key: 'bjc_eowg_name',
            title: '商品名称',            
            dataIndex:'bjc_eowg_name'
        },    
        {
            key: 'bjc_eowg_id',
            title: '编号',            
            dataIndex:'bjc_eowg_id',
            width:'3%'
        },    
        
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bjc_ctime + record.bjc_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <TechDocEdit
                            bjc_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bjc_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />  
                        <CourseList 
                            bjc_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsJiaoChengDelMutation()
    const [form] = Form.useForm();
    return (
        <Main selectedKeys={['/TeachList']}>
            <Flex justify='space-between'>
                <Form 
                    initialValues={{bjc_eowg_id:query.bjc_eowg_id,bjc_eowg_type_id:query.bjc_eowg_type_id}}
                    layout='inline'
                    form={form}
                >
                    <WebGoodsTypeSelect
                        label='商品类型'
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            setQuery(prevState=>({...prevState,bjc_eowg_type_id:e,bjc_eowg_type_name:f}))
                        }}  
                        name='bjc_eowg_type_id'
                        style={{width:'200px'}}
                    />
                    <SonTypeSelect
                        label='系统名称'
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            setQuery(prevState=>({...prevState,bjc_eowg_id:e,bjc_eowg_name:f}))
                        }}  
                        eowgt_id={query.bjc_eowg_type_id}
                        name='bjc_eowg_name'
                        style={{width:'200px'}}
                    />      
                    <Form.Item>
                        <Space>
                            <Button onClick={() => {
                                form.submit();
                            }}>查询</Button>
                            <Button onClick={() => {form.resetFields();setQuery(prevState=>({...prevState,bjc_eowg_id:'',bjc_eowg_type_id:''}))}}>重置</Button>
                        </Space>
                    </Form.Item> 
                </Form>
                <TeachAdd/>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
            />
        </Main>
    )
}

export default TeachList